import type { InvoiceData } from "@/apis/gql/types";
import { gql } from "@apollo/client";

export type TableInvoiceFragment = Pick<
  InvoiceData,
  | "invoiceId"
  | "aiSummary"
  | "totalAmount"
  | "currency"
  | "dueDate"
  | "invoiceDate"
  | "invoiceNo"
  | "invoiceSource"
  | "fileBlobName"
  | "supplierId"
  | "split"
  | "splitPdf"
  | "supplierMatch"
  | "supplierMatchConfidence"
  | "ocrReviewed"
  | "createdAt"
  | "status"
  | "fileName"
  | "reviewType"
  | "serviceDate"
  | "totalAmountConfidence"
  | "serviceDateConfidence"
  | "invoiceDateConfidence"
  | "invoiceNoConfidence"
  | "processingStatus"
  | "validationErrors"
  | "isBooking"
  | "isDuplicate"
  | "documentTypeSummary"
  | "accountIds"
  | "accountConfidence"
  | "taxCodeIds"
  | "taxCodeConfidence"
  | "buJustification"
  | "costCenterIds"
  | "tenantId"
  | "isPaid"
  | "supplierName"
  | "smbReviewStatus"
  | "errorReason"
  | "reconTriggered"
  | "paymentAmountToPay"
  | "type"
>;

export const TABLE_INVOICE_FRAGMENT = gql`
  fragment TableInvoice on Invoice {
    invoiceId
    aiSummary
    totalAmount
    currency
    dueDate
    invoiceDate
    invoiceNo
    invoiceSource
    fileBlobName
    supplierId
    split
    splitPdf
    supplierMatch
    supplierMatchConfidence
    ocrReviewed
    createdAt
    status
    fileName
    reviewType
    serviceDate
    totalAmountConfidence
    serviceDateConfidence
    invoiceDateConfidence
    invoiceNoConfidence
    processingStatus
    validationErrors
    isBooking
    isDuplicate
    documentTypeSummary
    accountIds
    accountConfidence
    taxCodeIds
    taxCodeConfidence
    buJustification
    costCenterIds
    tenantId
    isPaid
    supplierName
    smbReviewStatus
    reconTriggered
    errorReason {
      code
      data
      message
    }
    paymentAmountToPay
    type
  }
`;
